var CarouselLayoutEnum;
(function (CarouselLayoutEnum) {
    CarouselLayoutEnum["default"] = "default";
    /** @deprecated */
    CarouselLayoutEnum["theatre"] = "theatre";
    CarouselLayoutEnum["overflow"] = "overflow";
})(CarouselLayoutEnum || (CarouselLayoutEnum = {}));
export default CarouselLayoutEnum;
//# sourceMappingURL=CarouselLayoutEnum.js.map